import React, { useMemo } from 'react';
import { reduce, prop, propOr, filter, includes, compose, equals, split, flatten, map, assoc, pluck, defaultTo, sortWith, ascend } from 'ramda';

const useUserOfferOptions = ({
  offers,
  selectedTeam,
  disabledOffers,
  currentTeamIsDisabled
}) => {
  const offersByTeamId = useMemo(() => compose(
    reduce((acc, curr) => {
      const teamId = prop('team', curr);
      const offerId = prop('id', curr);
      const offerName = prop('offerName', curr);
      const isArchived = propOr(false, 'isArchived', curr);
      if (isArchived) return acc;

      const option = { value: offerId, label: offerName };
      if (!acc[teamId]) {
        acc[teamId] = [option];
      } else {
        acc[teamId].push(option);
      }
      return acc;
    }, {}),
    filter(({ id, version }) => equals(id, prop('itemRootId', version)))
  )(offers), [offers]);

  const {
    selectedOptionsValue,
    filteredOption: offersOption
  } = useMemo(() => {
    const options = currentTeamIsDisabled ? [] : propOr([], selectedTeam, offersByTeamId);
    const disabledOfferNamesForSelectedTeam = propOr(
      [],
      selectedTeam,
      disabledOffers
    );
    const allDisabledOfferNames = compose(
      flatten,
      map(split(',')),
      filter(Boolean)
    )(disabledOfferNamesForSelectedTeam);

    const selectedOptionsValue = compose(
      defaultTo([]),
      pluck('value'),
      filter(({ label }) => includes(label, allDisabledOfferNames))
    )(options);
    const filteredOption = compose(
      sortWith([
        ascend(propOr(false, 'disabled')), 
        ascend(prop('label'))
      ]),
      map((option) => assoc('disabled', includes(prop('label', option), allDisabledOfferNames), option))
    )(options);
    return {
      selectedOptionsValue,
      filteredOption
    };
  }, [currentTeamIsDisabled, offersByTeamId, selectedTeam, disabledOffers]);

  return {
    selectedOptionsValue,
    offersOption
  };
};

export default useUserOfferOptions;